import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { gaPageview } from '../lib/googleAnalytics'

/** GA4 SPA pageview při změně cesty. První načtení už poslal gtag('config') v index.html. */
export default function GoogleAnalytics() {
  const { pathname } = useLocation()
  const first = useRef(true)
  useEffect(() => {
    if (first.current) { first.current = false; return }
    gaPageview(pathname)
  }, [pathname])
  return null
}
